import React from 'react';

import CreateFromSchemaButton from 'processes/dashboard/CreateFromSchemaButton';
import {OpenCreateModalArgs} from 'requests/dashboard/openCreateRequestModal';
import {RequestTemplate} from 'requests/templates/RequestTemplateConstants';

import {RequestSchema} from '../RequestConstants';
import {RequestTaskSchema} from '../tasks/RequestTaskConstants';
import getInitialRequestProps from '../templates/getInitialRequestProps';

export interface NewRequestDropdownProps {
  schemas: Array<RequestSchema> | null;
  onOpenCreateModal: (openModalArgs: OpenCreateModalArgs) => void;
  requestTemplatesById: {[id: string]: RequestTemplate};
  requestTaskSchemasById: {[id: string]: RequestTaskSchema};
}

export default function NewRequestDropdown(props: NewRequestDropdownProps): JSX.Element {
  function hasSchemasAndAllTemplates(): boolean {
    if (props.schemas == null || props.requestTemplatesById == null) {
      return false;
    }
    for (const schema of props.schemas) {
      for (const templateId of schema.requestTemplateIds) {
        if (props.requestTemplatesById[templateId] == null) {
          return false;
        }
      }
    }
    return true;
  }

  return (
    <CreateFromSchemaButton
      schemas={hasSchemasAndAllTemplates() ? props.schemas : null}
      onSelect={(schema: RequestSchema) => {
        props.onOpenCreateModal(
          getInitialRequestProps(schema, props.requestTemplatesById, props.requestTaskSchemasById)
        );
      }}
    />
  );
}
